// 第三方登录类
class thirdPartyLogin {
    constructor(store, trend) {
        this.store = store;
        this.moreTrend = trend;
    }

    init({userToken}) {
        let contactFlag = this.moreTrend.includes('?') ? '&' : '?';
        this.moreTrend += `${contactFlag}userToken=${userToken}`;
        this.store.dispatch('updateSourceSwitch', {source:'moreTrend', val: this.moreTrend});
        //console.log('设置行情userToken')
    }
}

// 第三方的插件
export default function thirdParty (store) {
    let trendSource = store.getters.getSourceSwitch('moreTrend');
    if (!trendSource) return false;
    store.subscribe(({type, payload}) => {
        // 如果不是执行 更新用户 token操作， 则终止
        if(type != 'updateUserInfo') return;
        if(typeof payload != 'object') return;
        if(!payload)return;
        if (Object.keys(payload).length == 0) return;
        const thirdPartyLoginObj = new thirdPartyLogin(store, trendSource);
        thirdPartyLoginObj.init(payload);
    });
}



// WEBPACK FOOTER //
// ./src/store/plugins/thirdParty.js